import { Typography, IconButton, Stack } from '@mui/joy';
import EditIcon from '@mui/icons-material/Edit';
import { EmojiDisplay } from '@/components/EmojiDisplay';

export function EditableText({ value, emoji, level = 'title-md', onEdit, sx }) {
  const handleClick = (e) => {
    e.stopPropagation();    
    onEdit();    
  };

  return (
    <Stack gap={1} direction="row" alignItems="center" sx={{ flexGrow: 1, ...sx }}>      
      {emoji && <EmojiDisplay emoji={emoji} size={20} />}
      <Typography 
        level={level} 
        sx={{ 
          flexGrow: 1,
          fontWeight: 500,
          fontSize: level === 'title-sm' ? '14px' : '16px',
        }}
      >
        {value}
      </Typography>            
      <IconButton size="sm" variant="plain" onClick={handleClick}>
        <EditIcon />
      </IconButton>      
    </Stack>
  );
}

